module.exports = __webpack_public_path__ + "static/michaelwayne-57e7341bdcb53736e924262ba036c6a7.jpg";